import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/KeypalCard.vue';
// import SafeBox from "../views/SafeBox.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/tutorials',
    name: 'KeyPalCardInstructions',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/KeyPalCardInstructions.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

// 获取原型对象push函数
const originalPush = VueRouter.prototype.push;

// 获取原型对象replace函数
const originalReplace = VueRouter.prototype.replace;

// 修改原型对象中的push函数
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

// 修改原型对象中的replace函数
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err);
};

export default router;
